module.exports = __webpack_public_path__ + "static/media/koala-army.dee61e7b.jpg";